<template>
  <!-- Did wrapper need to track changes. Somehow v-menu does not rerender on resize -->
  <div>
    <v-menu id="menu" offset-y full-width nudge-bottom="20px" nudge-left="20px">
      <template v-slot:activator="{ on }">
        <v-btn id="buttonAccount" flat color="transparent" v-on="on">
          <span class="black--text">{{ user ? user.name : null }}</span>
          <v-avatar v-if="avatar" size="24px" class="v-icon v-icon--right">
            <img :src="avatar.link">
          </v-avatar>
          <v-icon v-else right color="#dddddd">
            account_circle
          </v-icon>
        </v-btn>
      </template>
      <v-list id="list" flat dense>
        <v-subheader>{{ user ? user.email : null }}</v-subheader>
        <v-divider />
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          v-ripple
          @click="$emit(item.callback)"
        >
          <v-list-tile-avatar size="20">
            <v-icon class="menu-icon">
              {{ item.icon }}
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => ({})
    }
  },

  data() {
    return {
      avatar: null
    }
  },

  computed: {
    ...mapState('common', ['isMobile'])
  },

  watch: {
    user() {
      this.updateAvatar()
    }
  },

  mounted() {
    this.updateAvatar()
  },

  methods: {
    updateAvatar() {
      this.avatar =
        this.user && this.user.media
          ? this.user.media.find(item => item.type === 'avatar')
          : undefined
    }
  }
}
</script>

<style scoped lang='sass'>
#buttonAccount
  text-transform: none
  padding: 0 0.5rem
  @media only screen and (min-width: 600px)
    padding: 0rem 1rem
  @media only screen and (max-width: 760px)
    margin-right: 0 !important
    margin-left: 0 !important

#buttonAccount span
  text-transform: capitalize

.v-menu__content
  border-radius: 5px

.v-list
  min-width: 200px

#list >>> .v-list__tile,
.v-subheader
  padding: 0 1rem
  height: 3rem
  font-size: $hwayzFont1rem2

.v-list__tile__title
  margin-left: -2rem

.v-avatar .v-icon
  font-size: $hwayzFont1rem8 !important

.v-divider
  margin: 0
.menu-icon
  padding-right: 5px

@media only screen and (max-width: 600px)
  .menu-account
    display: none

</style>
